import imageCompression from 'browser-image-compression';

/**
 * Comprime una imagen antes de subirla, con la misma librería que Avance de obra
 * (browser-image-compression: respeta la orientación EXIF y trabaja en un web worker).
 *  - Por defecto: máx. 1 MB y 1440 px por el lado mayor (suficiente para Instagram 1080 × 1350).
 *  - No toca videos, GIF (pueden ser animados) ni SVG.
 *  - Si el resultado no es más ligero, o el navegador no puede leer el formato, regresa el original.
 * Devuelve { archivo, antes, despues } en bytes.
 */
export default async function comprimirImagen(file, { maxSizeMB = 1, maxWidthOrHeight = 1440 } = {}) {
    const antes = file.size;
    const tipo = (file.type || '').toLowerCase();
    if (!tipo.startsWith('image/') || tipo === 'image/gif' || tipo === 'image/svg+xml') return { archivo: file, antes, despues: antes };
    const opciones = { maxSizeMB, maxWidthOrHeight, initialQuality: 0.85 };
    // Con límite de tiempo: si el navegador se atora (worker bloqueado, foto enorme), se sube la original
    const conLimite = (promesa, ms) => Promise.race([promesa, new Promise((_, mal) => setTimeout(() => mal(new Error('tiempo')), ms))]);
    try {
        let blob;
        try { blob = await conLimite(imageCompression(file, { ...opciones, useWebWorker: true }), 20000); }
        catch (_) { blob = await conLimite(imageCompression(file, { ...opciones, useWebWorker: false }), 20000); } // respaldo sin worker
        if (!blob || blob.size >= antes) return { archivo: file, antes, despues: antes };
        const archivo = new File([blob], file.name, { type: blob.type || tipo, lastModified: Date.now() });
        return { archivo, antes, despues: archivo.size };
    } catch (_) {
        return { archivo: file, antes, despues: antes };
    }
}

export const pesoTxt = (b) => (b >= 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(b / 1024))} KB`);
